exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#info-container[data-v-0c6fa005] {\n  display: block;\n  position: absolute;\n}\nh2[data-v-0c6fa005] {\n  color: white;\n  text-shadow: 0px 0px 2px black;\n  font-weight: normal;\n  font-size: 1.3vw;\n}\n", ""]);

// exports
